export class InvalidTokenError extends Error {}
export class BasketTransferError extends Error {}

export class GraphQLError extends Error {
  code?: number | string;

  constructor(message: string, code: number | string) {
    super(message);
    this.code = code;
    this.name = 'GraphQLError';
  }
}

export const handleSWRErrors = (error: unknown, action: () => void): boolean => {
  if (error instanceof InvalidTokenError) {
    action();

    return true;
  }
  if (error instanceof BasketTransferError) {
    action();

    return true;
  }

  return false;
};
